var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 8.74423V31.3755C14.4339 30.5709 10.1212 25.752 10.1212 19.9739V12.2303C14.6909 12.2303 16.462 10.786 20 8.74423ZM33.125 9.45983V19.9529C33.125 27.707 27.368 33.9302 20 35C12.6247 33.929 6.875 27.7044 6.875 19.9529V9.45983C13.0206 9.45983 14.8795 7.95396 20 5C25.171 7.98323 26.9151 9.45983 33.125 9.45983ZM20 6.98732C15.9089 9.37277 13.5517 11.0205 8.56393 11.18V19.9529C8.56393 26.6905 13.5817 32.2674 20 33.2525C26.4183 32.2674 31.4361 26.6905 31.4361 19.9529V11.18C26.4479 11.0205 24.0911 9.37277 20 6.98732Z",
    fill: "#2A3842"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.9844f0cb0aa8fd2f560fc6191be18f24.svg";
export { ForwardRef as ReactComponent };